class slickTsSkeepersJs{

    constructor(
        elementSkeepersSlick
    ) {
        this.elementSkeepersSlick = elementSkeepersSlick;
    }

    bindEvents() {
        if(this.elementSkeepersSlick[0].parentNode.parentNode.style.display !== "none"){
            this.elementSkeepersSlick.not('.slick-initialized').slick({
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
                adaptiveHeight: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    }

}
document.addEventListener('DOMContentLoaded', () => {
    if (typeof $('.skeepers-slider .skeepers-slide') != "undefined" && $('.skeepers-slider .skeepers-slide').length > 0) {
        let v = new slickTsSkeepersJs(
            $('.skeepers-slider')
        );
        v.bindEvents();
    }
});